import { Injectable } from '@angular/core';
import { Moment } from 'moment';

@Injectable({
    providedIn: 'root'
})
export class DateTimeUtilsService {

    constructor() { }

    /**
     * Convert given date into a format favourable for backend. Conversion will returns
     * date as a string without timezone information
     */
    public convertDateFormBackend(date: Date): string {
        if (!date)
            return null;

        return date.toString().split(" GMT")[0];
    }

    /**
     * Convert given date into a format favourable for backend. Conversion will returns
     * date as a string without timezone information
     */
    public convertMomentForBackend(date: Moment | Date): string {
        if (!date)
            return null;

        if (typeof (date as Moment).toDate === 'function')
            return this.convertDateFormBackend((date as Moment).toDate());
        else
            return this.convertDateFormBackend(date as Date);
    }
}
